import type { FC, PropsWithChildren } from 'react';

import { SideBar } from '@xing-com/platform-layout-side-bar';
import { CenterContainer } from '@xing-com/platform-layout-view-wrapper';
import { GridContainer } from '@xing-com/xing-grid';

import {
  StyledSideBarWrapper,
  StyledScrollWrapper,
  StyledContainer,
  StyledMain,
} from './layout-main.styles';

type LayoutMainInnerWrappersProps = {
  gridless?: boolean;
};

export const LayoutMainInnerWrappers: FC<
  PropsWithChildren<LayoutMainInnerWrappersProps>
> = ({ children, gridless = false }) => {
  return (
    <CenterContainer>
      {/* Hide sidebar if LoggedOut */}
      <StyledSideBarWrapper $gridless={gridless}>
        <SideBar />
      </StyledSideBarWrapper>

      <StyledScrollWrapper>
        <StyledContainer $gridless={gridless}>
          <StyledMain $gridless={gridless} id="content">
            {gridless ? (
              children
            ) : (
              <GridContainer type="standard" withSidenav>
                {children}
              </GridContainer>
            )}
          </StyledMain>
        </StyledContainer>
      </StyledScrollWrapper>
    </CenterContainer>
  );
};
